/**
 * @desc 收款码支付结果轮询接口
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** merchantNo */
  merchantNo: string
  /** merchantTradeNo */
  merchantTradeNo: string
  /** sign */
  sign: string
  /** timestamp */
  timestamp: string
  /** transactionId */
  transactionId: number
}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/payment/paymentResult',
    params,
    method: 'get',
  })
}
